import { Authenticated } from "@refinedev/core"
import { NavigateToResource } from "@refinedev/react-router-v6";
import { Outlet, Route } from "react-router-dom"
import { ForgotPasswordPage } from "../pages/forgotPassword/forgotPassword"
import Register from "../pages/register"
import { ResetPasswordPage } from "../pages/resetPassword/resetPassword"
import ConfirmEmail from "../pages/register/confirmEmail"
import { LoginPage } from "../pages/login/login";
import TenantSignup from "../pages/tenantSignup/signup"
import ActivateTenant from "../pages/tenantSignup/activateTenant"
import ResendActivation from "../pages/tenantSignup/resendActivation"
import AcceptInvitation from "../pages/acceptInvitation/acceptInvitation"
import { isTenantSignupEnabled } from "../shared/tenantSignup"
/*
<Authenticated
                key="authenticated-outer"
                fallback={<Outlet />}
            >
                <NavigateToResource />
            </Authenticated>
            */
export const AuthRoutes = (
    <Route
        element={
            <Outlet />
        }
    >
        <Route path="/login"
            element={<LoginPage />}
        />
        <Route path="/register"
            element={<Register />}
        />
        <Route
            path="/forgot-password"
            element={<ForgotPasswordPage />}
        />
        <Route
            path="/reset-password"
            element={<ResetPasswordPage />}
        />
        <Route
            path="/confirm-email"
            element={<ConfirmEmail />}
        />
        <Route
            path="/accept-invitation"
            element={<AcceptInvitation />}
        />
        {isTenantSignupEnabled && (
            <Route
                path="/signup"
                element={<TenantSignup />}
            />
        )}
        {/* Deliberately NOT gated on isTenantSignupEnabled:
            - /activate-tenant must keep resolving links already emailed to tenants that
              signed up before signup was switched off.
            - /resend-activation is not exclusive to tenant signup — it also re-sends the
              ordinary email confirmation for users created via /register, which is the
              recovery path the login page offers for `userNotActivated`. */}
        <Route
            path="/activate-tenant"
            element={<ActivateTenant />}
        />
        <Route
            path="/resend-activation"
            element={<ResendActivation />}
        />
    </Route>
)